import { render } from 'react-dom';
import AppComponent from './AppComponent';
import { jsx as _jsx } from "react/jsx-runtime";
export const setupApp = (store, history) => {
  const rootElement = document.getElementsByClassName('page')[0];
  render( /*#__PURE__*/_jsx(AppComponent, {
    history: history,
    store: store
  }), rootElement);
};